import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editSingleAppAction = createAsyncThunk(
    'edit-single-app-details',
    async (data, { rejectWithValue }) => {
        console.log("data---->",data)
        try {
            const res = await axios.post(`/admins/api/updateApp`,data) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editSingleAppSlice = createSlice({
    name: 'edit-single-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editSingleAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editSingleAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editSingleAppAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editSingleAppReducer = editSingleAppSlice.reducer